import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBiMoMjxkqbiLHwAuqj61uRXAz5wBqlx-I",
  authDomain: "fade-89413.firebaseapp.com",
  projectId: "fade-89413",
  storageBucket: "fade-89413.appspot.com",
  messagingSenderId: "233293626033",
  appId: "1:233293626033:web:9b589face8acbcc1e50090"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export {db, auth};